import React from 'react';

import { useIntl } from 'react-intl';

import { routes } from 'utils/routing';

import { UnauthenticatedEmptyStateImage } from './images';
import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const LoggedOutEmptyState = () => {
  const { formatMessage } = useIntl();

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <UnauthenticatedEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{formatMessage({ id: 'unauthenticatedRecentItemsHeader' })}</HeaderText>
      <SubText>{formatMessage({ id: 'unauthenticatedRecentItemsSubtext' })}</SubText>
      <StyledActionButtonLink to={routes.signIn}>
        {formatMessage({ id: 'logIn' })}
      </StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};

export default LoggedOutEmptyState;
